import * as React from 'react'

import { Box, Link, Section, Spinner, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import OauthService, { LOGIN_PATH } from 'modules/payroll_integrations_a3innuva/lib/OauthService'
import { Status } from 'modules/payroll_integrations_a3innuva/lib/OauthService'

import Tag from './Tag'

const IntegrationLinkStatus = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const isBookkeeperView = useBookkeeperView()
  const loginUrl = buildUrl(`${LOGIN_PATH}/?company_id=${companyId}`)

  const [status, setStatus] = React.useState<Status>()

  async function connect() {
    const oauthStatus = await OauthService.getStatus({ companyId: companyId }, isBookkeeperView)
    setStatus(oauthStatus)
  }

  const { loading } = useAsyncData(async () => {
    const oauthStatus = await OauthService.getStatus({ companyId: companyId }, isBookkeeperView)
    setStatus(oauthStatus)
  }, [])

  if (loading || !status) return <Spinner />

  return (
    <Section
      description={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.login.description'
      )}
      illustration="common-file-text-upload"
      title={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.login.title'
      )}
    >
      <Box
        background="grey200"
        padding="s24"
        style={{ marginTop: '40px' }}
        borderRadius={{ all: 'abs008' }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
      >
        <Text.Normal size="300" weight="semibold">
          {i18n.t(
            'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.login.status_card.title'
          )}
        </Text.Normal>

        <Tag status={status!} />

        {!(status === Status.Authenticated) && (
          <Link.Href href={loginUrl}>
            {i18n.t('payroll_integrations.incidences.a3innuva.not_authenticated.submit')}
          </Link.Href>
        )}
      </Box>
    </Section>
  )
}

export default observer(IntegrationLinkStatus)
